import classNames from "classnames";
import AscButton from "../AscButton/AscButton";
import { QuestionMarkIllustration } from "../AscIllustrations";
import AscLink from "../AscLink/AscLink";
import styles from "./AscEmptyStateCard.module.scss";

export interface AscEmptyStateCardProps {
  className?: string;
  actionButtonText?: string;
  actionButtonLink?: string;
}

export default function AscEmptyStateCard({
  className,
  actionButtonText = "Let's start!",
  actionButtonLink,
}: AscEmptyStateCardProps) {
  return (
    <div
      data-testid="asc-empty-state-card"
      className={classNames(styles.ground, className)}
    >
      <QuestionMarkIllustration className={styles.emptyIcon} />
      {actionButtonLink && (
        <AscLink href={actionButtonLink} disabled={!actionButtonLink}>
          <AscButton>{actionButtonText}</AscButton>
        </AscLink>
      )}
    </div>
  );
}
